import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IHeroImage } from "InterfacesTypes/interfaces";

export interface ImageState {
  imageItems: IHeroImage[];
  loading: boolean;
  error: string | null;
}

const initialState: ImageState = {
  imageItems: [],
  loading: false,
  error: null,
};

export const fetchImages = createAction("image/fetchImages");

export const imageSlice = createSlice({
  name: "image",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IHeroImage[]>) {
      state.loading = false;
      state.imageItems = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setImages(state, action: PayloadAction<IHeroImage[]>) {
      state.imageItems = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setImages } =
  imageSlice.actions;

export const heroImageReducer = imageSlice.reducer;
